import { createFileRoute, redirect } from "@tanstack/react-router"

// Legacy URL, kept so old bookmarks resolve.
export const Route = createFileRoute("/_auth/demand/_layout/calendar")({
  beforeLoad: () => {
    throw redirect({ to: "/demand/sales-and-demand" })
  },
})
